import { computed } from 'vue';
import { useMarxentIndicator } from '~/composables/useMarxentIndicator';
import useVtoImageIndicator from '~/composables/useVtoImageIndicator';

export const IMAGE_INDICATOR_AND_VIDEO_EXIST = 4;
export const IMAGE_INDICATOR_AND_VIDEO_NOT_EXIST = 3;

/**
 * Composable to manage AR and VTO indicator logic.
 */
export const useARIndicator = (videoId: ComputedRef<string>) => {
  // TODOS: bad pattern to check for route. Come up with better solution
  const isPdpRoute = useRoute().name !== 'writeReview';
  const vtoEligibleExperiment = isPdpRoute ? useVtoImageIndicator() : ref(false);
  const { isMarxentImageIndicator, marxentUrlForMobile } = isPdpRoute
    ? useMarxentIndicator()
    : { isMarxentImageIndicator: ref(false), marxentUrlForMobile: ref(null) };

  const imageIndicatorEnabled = computed(() => isMarxentImageIndicator.value || vtoEligibleExperiment.value);

  const indicatorIndex = computed(() => {
    if (imageIndicatorEnabled.value) {
      return videoId.value ? IMAGE_INDICATOR_AND_VIDEO_EXIST : IMAGE_INDICATOR_AND_VIDEO_NOT_EXIST;
    }
  });

  return {
    indicatorIndex,
    imageIndicatorEnabled,
    vtoEligibleExperiment,
    marxentUrlForMobile,
  };
};
